import apiClient from './api-client'

function getDiseases(id) {
  return apiClient.get(`patients/${id}/diseases`)
}

function getAllDiseases() {
  return apiClient.get(`/diseases`)
}

function addDiseaseToPatient(patiendId, id) {
  return apiClient.post(`patients/${patiendId}/diseases/${id}`)
}

function removeDiseaseFromPatient(patiendId, id) {
  return apiClient.destroy(`patients/${patiendId}/diseases/${id}`)
}

const Diseases = {
  getAllDiseases,
  getDiseases,
  addDiseaseToPatient,
  removeDiseaseFromPatient,
}

export default Diseases
